import { EnumExamType, IExam, ILesson, IModule, ISelectValue } from "@/@types";
import { DataTableFacetedFilter } from "@/components/data-table/faceted-filter";
import { Table } from "@tanstack/react-table";

interface Props {
  table?: Table<IExam>;
  modules?: IModule[];
  lessons?: ILesson[];
}

export function TableToolbar({ table, modules, lessons }: Props) {
  const MODULES: ISelectValue[] = [
    ...new Set(modules?.map(({ name }) => ({ label: name, value: name }))),
  ];
  const LESSONS: ISelectValue[] = [
    ...new Set(lessons?.map(({ title }) => ({ label: title, value: title }))),
  ];

  if (!table) return null;

  return (
    <>
      {MODULES && MODULES.length > 0 && (
        <DataTableFacetedFilter
          title={EnumExamType.MODULE_TEST}
          table={table}
          columnId="moduleName"
          options={MODULES}
        />
      )}

      {LESSONS && LESSONS.length > 0 && (
        <DataTableFacetedFilter
          title={EnumExamType.LESSON_TEST}
          table={table}
          columnId="lessonName"
          options={LESSONS}
        />
      )}
    </>
  );
}
